import { useEffect } from 'react';

import { browserMetrics } from '@atlassian/browser-metrics';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

import { isInitial } from './utils/index.ts';

type PageLoadMarkFMPProps = {
	timestamp?: number;
};

/**
 * This component allows to mark customized FMP metric on page-load event.
 */
const PageLoadMarkFMPComponent = ({ timestamp }: PageLoadMarkFMPProps) => {
	const pageLoadMetric = browserMetrics.getPageLoadMetric();

	useEffect(() => {
		if (typeof timestamp === 'number') {
			pageLoadMetric.markFMP(timestamp);
		} else {
			pageLoadMetric.markFMP();
			try {
				performance.mark('browser-metric.fmp');
				performance.measure(
					'browser-metric:fmp',
					isInitial() ? undefined : 'browser-metric.start',
					'browser-metric.fmp',
				);
			} catch (e) {
				// Suppress error when performance API failed.
				// Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
				// That's why wrap with try catch statement.
			}
		}
	}, [timestamp, pageLoadMetric]);

	return null;
};

export const PageLoadMarkFMP = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(PageLoadMarkFMPComponent);
